export const getToken = () => localStorage.getItem('token');
export const setToken = (t) => t ? localStorage.setItem('token', t) : localStorage.removeItem('token');
export const getStoredUsername = () => localStorage.getItem('username') || '';
export const setStoredUsername = (u) => u ? localStorage.setItem('username', u) : localStorage.removeItem('username');
export const setStoredUserId = (id) => id ? localStorage.setItem('userId', String(id)) : localStorage.removeItem('userId');

export async function apiFetch(url, options = {}) {
    const token = getToken();
    const headers = {...(options.headers || {})};
    if (token) headers['Authorization'] = 'Bearer ' + token;
    const res = await fetch(url, {...options, headers});
    if (res.status === 401) {
        window.dispatchEvent(new Event('auth:logout'));
    }
    return res;
}
